import API from '.';

export default class RealEstateInterest {
  /**
   * @param {number} realEstateInterestId Id of the realEstateInterest.
   * @param {number} realEstateInterestTypeId type of the realEstateInterest.
   * @param {string} realEstateInterestName Name of the realEstateInterest.
   * @param {string} realEstateInterestDesc Description of the realEstateInterest.
   * @param {number} realEstateInterestLatitude Latitude of the realEstateInterest.
   * @param {number} realEstateInterestLongitude Longitude of the realEstateInterest.
   * @param {number} realEstateInterestFrontageSize FrontageSize of the realEstateInterest.
   * @param {number} realEstateInterestDepthSize DepthSize of the realEstateInterest.
   * @param {number} realEstateInterestArea Area of the realEstateInterest.
   * @param {string} realEstateInterestSizeUOM SizeUOM of the realEstateInterest.
   * @param {string} realEstateInterestBusinessLineAlias BusinessLineAlias of the realEstateInterest.
   * @param {null} parcel relation to parcel
   * @param {null} realEstateInterestOwnerRelate relation to owner.
   * @param {null} realEstateInterestValuationRelate relation to interestValuation.
   * @param {Array} realEstateInterestSourceSystemRelate relation with source system.
   */

  constructor({
    realEstateInterestId,
    realEstateInterestTypeId,
    realEstateInterestName,
    realEstateInterestDesc,
    realEstateInterestArea,
    realEstateInterestSizeUOM,
    parcel,
    realEstateInterestOwnerRelate,
    realEstateInterestValuationRelate,
    realEstateInterestSourceSystemRelateData,
    isPrimaryRealEstateInterest,
    locationId,
  }) {
    this.realEstateInterestId = realEstateInterestId;
    this.realEstateInterestTypeId = realEstateInterestTypeId;
    this.realEstateInterestName = realEstateInterestName;
    this.realEstateInterestDesc = realEstateInterestDesc;
    this.realEstateInterestArea = realEstateInterestArea;
    this.realEstateInterestSizeUOM = realEstateInterestSizeUOM;
    this.parcel = parcel;
    this.realEstateInterestOwnerRelate = realEstateInterestOwnerRelate;
    this.realEstateInterestValuationRelate = realEstateInterestValuationRelate;
    this.realEstateInterestSourceSystemRelateData = realEstateInterestSourceSystemRelateData;
    this.isPrimaryRealEstateInterest = isPrimaryRealEstateInterest;
    this.locationId = locationId;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/RealEstateInterest');
    return data.map((d) => new RealEstateInterest(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`/RealEstateInterest/${id}`);
    return new RealEstateInterest(data);
  }
  static async getBySearchText(searchText) {
    const api = await API();
    const { data } = await api.get('RealEstateInterest/search', {
    params: {
      searchText: searchText,
    },
  });
   return data.map((d) => new RealEstateInterest(d));
  }
}
